var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29.82 18.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.55,0H29.82V2.69H12.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,0H11.3V8.07H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.55,5.38H29.82V8.07H12.55Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,10.76H29.82v2.69H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,16.14H29.82v2.69H0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagIcon);
export default __webpack_public_path__ + "static/media/flagIcon.f0f9dc1fcadf80aba06e4b67d082d7e1.svg";
export { ForwardRef as ReactComponent };